import { BaseNumberIdDataDto } from '../../../classes/common';
export class VehicleModelWithNameOnlyDto extends BaseNumberIdDataDto {
    constructor(initializer) {
        super(initializer);
        this.name = initializer.name;
    }
}
